package one.healthium.insights.domain.models

import one.healthium.insights.domain.content.ContentOptions

data class SavedContentModel(
    val id: String,
    val contentOptions: ContentOptions,
    val content: ContentPreviewModel,
)
